exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LoginView-content {\n  width: 29.16667%;\n  float: left;\n  margin-left: 2.08333%;\n  margin-right: 2.08333%;\n  margin-left: 35.41667%;\n  padding-bottom: 80px; }\n\n.LoginView .LoginForm {\n  margin-top: 40px; }\n", ""]);

// exports
